import type { FaireProductEntity } from "../../entity_types/product";

export const p_94p6kms3ue: FaireProductEntity = {
  token: "p_94p6kms3ue",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Hoop Earrings - 7460",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/9541410c9ff731b38a7891821a1d367b136a977207e850d74d974a7b35b895af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a82e7261fc71830f5b13e9ac89cdbd544230b49a9e135c500a2a4fb82ceb3349.jpeg",
    "https://cdn.faire.com/fastly/a10a0080cbe38820fec0904859160673d0ed30dda493198a6fcb4493bfdd9629.jpeg",
    "https://cdn.faire.com/fastly/7dfb12958e3654bdcdff1efe7e4d1103ac38a54ee53e636c44666ca7d77d52fa.jpeg",
  ],
  priceDollars: 5.75,
  description:
    'Approx. 1.65"\n\n\n\nThese earrings are hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n\n\n\nSimple Gold Earrings | Waterproof & Sweatproof Jewelry | Simple Lightweight Earrings | Minimalist Earrings | Real Gold Dipped Earrings | Real Gold Plated Earrings | Stainless Steel Metal Earrings\n',
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:33.850Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
